
import { takeEvery } from '@zaibot/fsa-saga';
import 'arrayq';

import { fork, put } from '../../redux-saga';
import { emailArchiveResource, emailArchiveEditor, emailArchiveBatch } from './resource';

import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import CANCEL_EMAIL_PARTICIPANTS from '../../note/noteParticipantSelectPopup/actions/CANCEL';
import { notesResource, notesEditor } from '../../note/notes/resource';
import { hack } from '../../browser/launch';
import { participantsResource } from '../../participant/resource';
import { usergroupResource } from '../../usergroup/resource';
import { IEmailMessage, INote, INoteParticipant, IParticipant, IQuestionAddressee, IUsergroup } from '../../types';
import { getDocumentName } from '../../settings';
import { isType } from '@zaibot/fsa';
import EMAIL_START_SEND_NOTIFICATION_NOTE from '../actions/EMAIL_START_SEND_NOTIFICATION_NOTE';
import { questionaddresseeResource } from '../../questionaddressee/resource';

function sendmailaddresses(note: INote, allparticipants: INoteParticipant[], allUsergroups: IUsergroup[], defaultQuestionAddressee: IQuestionAddressee) {

    var userids = note.noteParticipantsIDs;
    const selectedUsergroups: IUsergroup[] = note.noteParticipantGroupIDs ? allUsergroups.qWhere((usergroup) => 
        (note.noteParticipantGroupIDs ? note.noteParticipantGroupIDs.qSelect((x)=> parseInt(x)).qIncludes(usergroup.id): false)): undefined; 
    if (selectedUsergroups) {
        selectedUsergroups.map((usrgr) => {  
            if (userids&&userids.length) {
                userids = userids.concat(usrgr.userIDs);
            } else {
                userids = usrgr.userIDs;
            }
        }); 
    }

    var uniqueUseridsArray: string[]=[];
    if (userids) {
        uniqueUseridsArray = userids.filter((item, pos) => {
            return userids.indexOf(item) === pos;
        });
    }

    if (defaultQuestionAddressee && uniqueUseridsArray && uniqueUseridsArray.length>0) {
        return defaultQuestionAddressee.email + ';' + allparticipants.qWhere((participant) => uniqueUseridsArray.qIncludes(participant.id)).qSelect((i) => (i.email)).join(';');
    } else if (defaultQuestionAddressee) {
        return defaultQuestionAddressee.email;
    } else {
        return allparticipants.qWhere((participant) => uniqueUseridsArray.qIncludes(participant.id)).qSelect((i) => (i.email)).join(';');
    }
}

function sendmailnames(note: INote, allparticipants: INoteParticipant[], allUsergroups: IUsergroup[], defaultQuestionAddressee: IQuestionAddressee) {

    var userids = note.noteParticipantsIDs;
    const selectedUsergroups: IUsergroup[] = note.noteParticipantGroupIDs ? allUsergroups.qWhere((usergroup) => 
        (note.noteParticipantGroupIDs ? note.noteParticipantGroupIDs.qSelect((x) => parseInt(x)).qIncludes(usergroup.id): false)): undefined; 
    if (selectedUsergroups) {
        selectedUsergroups.map((usrgr) => {  
            if (userids&&userids.length) {
                userids = userids.concat(usrgr.userIDs);
            } else {
                userids = usrgr.userIDs;
            }

        }); 
    }

    var uniqueUseridsArray: string[] = [];
    if (userids) {
        uniqueUseridsArray = userids.filter((item, pos) => {
            return userids.indexOf(item) === pos;
        });
    }

    if (defaultQuestionAddressee && uniqueUseridsArray && uniqueUseridsArray.length>0) {
        return defaultQuestionAddressee.name + ';' + allparticipants.qWhere((participant) => uniqueUseridsArray.qIncludes(participant.id)).qSelect((i) => (i.name)).join(';');
    } else if (defaultQuestionAddressee) {
        return defaultQuestionAddressee.name;
    } else {
        return allparticipants.qWhere((participant) => uniqueUseridsArray.qIncludes(participant.id)).qSelect((i) => (i.name)).join(';');
    }
}

function sendmail(note: INote, create: boolean, user: IParticipant, allparticipants: INoteParticipant[], allparticipantsgroups: IUsergroup[], defaultQuestionAddressee: IQuestionAddressee): IEmailMessage {
    if (!((note.noteParticipantsIDs && note.noteParticipantsIDs.qAny()) ||
        (note.noteParticipantGroupIDs && note.noteParticipantGroupIDs.qAny()) )) { 
            if (!(note.isquestion&&defaultQuestionAddressee!==undefined)) {
                return undefined;
            }
        }

    const email: IEmailMessage = { 
        id: null,
        documentId: note.documentId ? note.documentId:'',
        htmlMail: '<p>' + note.text + '</p>',
        dateEmail: Date.now(),
        dateEmailString: new Date(Date.now()).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }), 
        mailToAddresses : sendmailaddresses(note, allparticipants, allparticipantsgroups, defaultQuestionAddressee),
        mailToName: sendmailnames(note, allparticipants, allparticipantsgroups, defaultQuestionAddressee),
        mailFromId: '',
        mailFromName: user ? user.name:'',
        mailFromAddress: user ? user.email:'',
        relatiebreadcrumb: '',
        relatiepageUrl: '',
        pageUrl: note.url ? note.url:'',
        pageId: note.pageId ? note.pageId : 0,
        pageBreadcrumb: note.breadcrumb ? note.breadcrumb:'',
        subject: 'Gedeelde ' + (note.isquestion ? 'vraag' : 'notitie') ,
        emailtext: (create ? 'Er is een ' + (note.isquestion ? 'vraag' : 'notitie') + ' met u gedeeld<br/>' : 'Een met u gedeelde ' + (note.isquestion ? 'vraag' : 'notitie') + ' is gewijzigd<br/>') +
                                '<strong>Inhoud: </strong>' +  note.text,
        isQuestion: note.isquestion,
        emailParticipantsIDs: [],
        defaultParticipantSet: false,
        noteIDs: [],        
        emailParticipantGroupIDs: [],     
        publicatie: getDocumentName(),         
    };

    return email;
}

export function* rootSaga(): Iterable<any> {
    yield fork(emailArchiveResource.saga);
    yield fork(emailArchiveEditor.saga);
    yield fork(emailArchiveBatch.saga);
    yield fork(signalEmailList);
    yield fork(signalEmailListWhenAuthenticated);   
    yield fork(signalEmailNote);   
    yield fork(sendNoteEmailNotificationsaga);  // Note participants
}

function* signalEmailList() {
    yield takeEvery([CANCEL_EMAIL_PARTICIPANTS], 
                     function*(){
        yield put(emailArchiveResource.actions.LIST({}));
    });
}

function* signalEmailListWhenAuthenticated() {
    yield takeEvery([AUTHENTICATED], 
                     function*(){        
        yield put(emailArchiveResource.actions.LIST({}));
    });
}

function* sendNoteEmailNotificationsaga() {
    yield takeEvery([EMAIL_START_SEND_NOTIFICATION_NOTE], function*(action){
        if (isType(action, EMAIL_START_SEND_NOTIFICATION_NOTE)) {
            yield put(emailArchiveResource.actions.CREATE({
                item: emailArchiveResource.create(
                    { ...action.payload.email },
                ) as IEmailMessage,
            }));

        }});
}

function* signalEmailNote() {
    yield takeEvery([
        notesResource.actions.CREATE_SUCCESS, notesResource.actions.UPDATE_SUCCESS,
    ], function*(action) {    
        
        const state = hack.store.getState();
        const item: INote = action.payload.item;
     
        const defaultQuestionAddressees = questionaddresseeResource.selectors.items(state).qSelect((item) => item as IQuestionAddressee);
        const defaultQuestionAddressee = !!item.isquestion&&defaultQuestionAddressees&&defaultQuestionAddressees.length>0 ? defaultQuestionAddressees[0]: undefined;

        if (((item.noteParticipantsIDs && item.noteParticipantsIDs.qAny()) ||
        (item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.qAny()) || 
        (item.isquestion&&defaultQuestionAddressees&&defaultQuestionAddressees.length>0))) {

            var domain = window.location.origin || `${window.location.protocol}//${window.location.host}`;
            var breadcrumb = item.breadcrumb; // getBreadcrumb();

            /* tslint:disable */
            const hasPublisher= Array.from(document.querySelectorAll('meta')).filter((x) => x.name.indexOf('lias-document-baseurl')>=0).length>0;        
            if (hasPublisher) {
                var baseUrl = Array.from(document.querySelectorAll('meta')).filter((x) => x.name.indexOf('lias-document-baseurl')>=0).qFirst().content;
                item.url = baseUrl.endsWith("/") ? `${baseUrl}${item.url}`:`${baseUrl}/${item.url}`;
            } else {
                item.url = breadcrumb==='Home'? domain : domain + '/p' + item.pageId.toString() + `.html`;
            }
            /* tslint:enable */

            const userparticipant = participantsResource.selectors.items(state).qFirst((itm) => itm.isUser);
            const allparticipants = participantsResource.selectors.items(state).qSelect((item) => item as IParticipant);
            const allparticipantsgroups = usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup);
            
            if (isType(action, notesEditor.actions.CREATE_CONTINUE)) {
                const email = sendmail(item, true, userparticipant, allparticipants, allparticipantsgroups, defaultQuestionAddressee);
                yield put(EMAIL_START_SEND_NOTIFICATION_NOTE({ email }));
            } else {
                const email = sendmail(item, false, userparticipant, allparticipants, allparticipantsgroups, defaultQuestionAddressee);
                email.id = 1; // is not being saved
                yield put(EMAIL_START_SEND_NOTIFICATION_NOTE({ email }));
            }
        }
    });
    
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/emailarchive/emails/sagas.tsx